import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Layout from '../components/layout/Layout';
import ClientDetail from '../components/clients/ClientDetail';
import { clientApi } from '../services/api';

const ClientDetailPage = () => {
  const [client, setClient] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  // Load client data when component mounts
  useEffect(() => {
    const fetchClient = async () => {
      try {
        const loadedClient = await clientApi.getById(id);
        setClient(loadedClient);
      } catch (error) {
        toast.error('Client not found');
        console.error('Error loading client:', error);
        navigate('/');
      }
    };
    
    fetchClient();
  }, [id, navigate]);

  // Handle client deletion
  const handleDelete = async (clientId) => {
    if (window.confirm('Are you sure you want to delete this client?')) {
      try {
        await clientApi.delete(clientId);
        toast.success('Client deleted successfully');
        navigate('/');
      } catch (error) {
        toast.error('Failed to delete client');
        console.error('Error deleting client:', error);
      }
    }
  };

  return (
    <Layout>
      <ClientDetail client={client} onDelete={handleDelete} />
    </Layout>
  );
};

export default ClientDetailPage;
